import { createReducer, on } from '@ngrx/store';

import { IFolder } from 'src/app/shared/interfaces/folder/ifolder';
import { loadFolderSuccess, saveFolderSuccess } from './folder.actions';

export interface IFolderState {
  lista: IFolder[];
}

const initialState: IFolderState = {
  lista: [],
};

console.log();
export const folderReducer = createReducer(
  initialState,
  on(loadFolderSuccess, (state, { lista }) => {
    console.log(lista);
    return {
      ...state,

      lista: [...lista],
    };
  }),

  on(saveFolderSuccess, (state, { folder }) => ({
    ...state,
    lista: [...state.lista, folder],
  }))
);
